import React, { memo } from "react";
import classnames from "classnames";
import Element from "src/components/base/element";

interface IProps {
    className?: string;
    children: React.ReactNode;
}

function MediaLeft(props: IProps) {
    const { className, children, ...rest } = props;
    return (
        <Element
            {...rest}
            className={classnames(
                "media-left",
                "basis-auto grow-0 shrink-0",
                "mr-[10px]",
                className
            )}
        >
            {children}
        </Element>
    );
}

export default memo(MediaLeft);
